import React from 'react';
import { SearchProvider } from '@contexts/SearchProvider';
import { ManageZoneList } from './ManageZoneList';
import { Search, TYPE } from '@components/Search';

export const ManageZone: React.FC = () => {
  const fieldProperties = [
    {
      labelName: 'provinceCode',
      name: 'code',
      type: TYPE.INPUT,
    },
    {
      labelName: 'provinceName',
      name: 'name',
      type: TYPE.INPUT,
    },
  ];

  return (
    <SearchProvider>
      <Search fieldProps={fieldProperties} />
      <ManageZoneList />
    </SearchProvider>
  );
};
